var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDiscount = function SvgDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 1.07,
    d: "M7.4 1.49a1.5 1.5 0 0 1 2.2 0l.77.84c.3.33.73.5 1.17.48l1.14-.05a1.5 1.5 0 0 1 1.56 1.56l-.05 1.14c-.02.44.15.87.48 1.17l.84.76c.65.6.65 1.62 0 2.22l-.84.76c-.33.3-.5.73-.48 1.17l.05 1.14a1.5 1.5 0 0 1-1.56 1.56l-1.14-.05a1.5 1.5 0 0 0-1.17.48l-.76.84a1.5 1.5 0 0 1-2.22 0l-.76-.84a1.5 1.5 0 0 0-1.17-.48l-1.14.05a1.5 1.5 0 0 1-1.56-1.56l.05-1.14a1.5 1.5 0 0 0-.48-1.17l-.84-.76a1.5 1.5 0 0 1 0-2.22l.84-.76c.33-.3.5-.73.48-1.17l-.05-1.14a1.5 1.5 0 0 1 1.56-1.56l1.14.05c.44.02.87-.15 1.17-.48l.76-.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.07,
    d: "M10.38 11.12a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5M6.63 7.38a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5m4.5-1.5-5.26 5.25"
  })));
};
export default SvgDiscount;